import React, { useState } from 'react';
import { FiChevronRight, FiCheckCircle, FiCode } from 'react-icons/fi';

const CodeExplanation = ({ steps, title }) => {
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <div className="code-explanation-container">
      <div className="code-explanation-header">
        <h3 className="code-explanation-title">
          <FiCode /> {title || 'Code Walkthrough'}
        </h3>
        <div className="step-progress">
          Step {currentStep + 1} of {steps.length}
        </div>
      </div>

      <div className="code-explanation-content">
        {/* Steps Navigation */}
        <div className="steps-sidebar">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
              onClick={() => setCurrentStep(index)}
            >
              <div className="step-number">
                {index < currentStep ? (
                  <FiCheckCircle className="step-check" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <div className="step-label">{step.title}</div>
            </div>
          ))}
        </div>

        {/* Current Step Content */}
        <div className="step-content">
          <div className="step-content-header">
            <h4>{steps[currentStep].title}</h4>
          </div>

          <div className="step-description">
            {steps[currentStep].description}
          </div>

          {/* Code Block with Line Highlight */}
          <div className="step-code-block">
            <div className="code-block-label">Code:</div>
            <pre className="step-code">
              {steps[currentStep].code.split('\n').map((line, idx) => (
                <div
                  key={idx}
                  className={`code-line ${
                    steps[currentStep].highlightLines?.includes(idx + 1) ? 'highlighted' : ''
                  }`}
                >
                  <span className="line-number">{idx + 1}</span>
                  <span className="line-content">{line}</span>
                </div>
              ))}
            </pre>
          </div>

          {/* Explanation */}
          {steps[currentStep].explanation && (
            <div className="step-explanation-box">
              <div className="explanation-label">💡 Explanation:</div>
              <div className="explanation-text">
                {steps[currentStep].explanation}
              </div>
            </div>
          )}

          {/* Output */}
          {steps[currentStep].output && (
            <div className="step-output-box">
              <div className="output-label">📤 Output:</div>
              <pre className="output-text">{steps[currentStep].output}</pre>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="step-navigation">
            <button
              className="btn btn-secondary"
              onClick={() => setCurrentStep(currentStep - 1)}
              disabled={currentStep === 0}
            >
              ← Previous
            </button>
            <button
              className="btn btn-primary"
              onClick={() => setCurrentStep(currentStep + 1)}
              disabled={currentStep === steps.length - 1}
            >
              Next → 
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeExplanation;

